import { StoreContext } from "@nosto/search-js/preact/common"
import { useContext } from "preact/hooks"
import { Store } from "../state"

/**
 * Use the store context
 *
 * @group Hooks
 */
export function useStore() {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return useContext(StoreContext) as Store
}
